export const convertHtmlToText = htmlText => {
  return htmlText && htmlText.replace(/<\/?[^>]+>/gi, " ");
};
